<div class="d-flex">
	<div class="display-6 ms-1 mt-2 mb-1">Canvases</div>
</div>
<p-divider></p-divider>
